import AuthService from "../../service";
const restaurant = {
  getRestaurant(page,search,sort_date) {
    return AuthService.get(`service/restaurant?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&search=${search}`
    );
  },
  showRestaurant(id) {
    return AuthService.get("/service/restaurant/" + id);
  },
  createRestaurant(data) {
    return AuthService.post("/service/restaurant", data);
  },
  updateRestaurant(id, data) {
    return AuthService.put("/service/restaurant/" + id, data);
  },
  deleteRestaurant(id) {
    return AuthService.delete("/service/restaurant/" + id);
  }
};
export default restaurant;
